import * as React from 'react'
import { ButtonProps, Tooltip } from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'
import { styled } from '@mui/material/styles'
import { css } from '@emotion/react'

interface IButtonProps extends ButtonProps {
    loading?: boolean
    golden?: boolean
    tooltip?: string
}

const StyledButton = styled(LoadingButton)<IButtonProps>`
    text-transform: none;

    ${({ golden, variant }) => {
        if (golden && variant === 'outlined') {
            return css`
                color: #ecd37c;
                border-color: #ecd37c80;
                &:hover {
                    background: #ecd37c20;
                    border-color: #ecd37c;
                }
            `
        }

        if (golden && variant === 'contained') {
            return css`
                background: #d4b95c;
                &:hover {
                    background: #d4b95c99;
                }
            `
        }
    }}
`

const Button = ({ children, tooltip, ...rest }: IButtonProps) => {
    return tooltip ? (
        <Tooltip arrow title={tooltip}>
            <span>
                <StyledButton {...rest}>{children}</StyledButton>
            </span>
        </Tooltip>
    ) : (
        <StyledButton {...rest}>{children}</StyledButton>
    )
}

export default Button
